/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Label2Inputs */

const vi_cmspostcategory_label2 = /** @type {(inputs: Cmspostcategory_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên chuyên mục`)
};

/**

* @param {Cmspostcategory_Label2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_label2 = /** @type {((inputs?: Cmspostcategory_Label2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Label2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_label2(inputs)
});
export { cmspostcategory_label2 as "cmsPostCategory_label" }